import React from 'react';
import WalletCard from './WalletCard';

function WalletPage({ session }) {
  return (
    <div>
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ 
          fontSize: '2rem', 
          marginBottom: '10px',
          fontFamily: 'Orbitron, sans-serif',
          color: 'var(--primary-color)'
        }}>
          💰 My Wallet
        </h2>
        <p style={{ color: 'var(--text-secondary)' }}>
          Manage your balance and recharge your wallet
        </p>
      </div>

      <WalletCard session={session} />
    </div>
  );
}

export default WalletPage;
